import React, { Fragment, useRef } from 'react';
import Countries from './Countries';
import ShowVat from './ShowVat';

const NavigationItem = ({
    logoSrc,
    links = [],
    additionalHeaderLinks = [],
    contentLink = null,
    width,
    listLength = 0,
}) => {
    const menuRef = useRef(null);
    const toggleMenu = () => {
        menuRef.current.classList.toggle('navbar__menu--show');
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                ></a>
            ) : (
                <Fragment>
                    {contentLink.url ? (
                        <a
                            className={`navbar__link ${selectedClass} ${
                                hasChildrenClass || ''
                            } ${additionClass || ''}`}
                            href={contentLink.url || '#'}
                            dangerouslySetInnerHTML={{
                                __html: contentLink.name,
                            }}
                        ></a>
                    ) : (
                        <div
                            className={`navbar__no-link${
                                listLength === 1
                                    ? ' navbar__no-link--single-item'
                                    : ''
                            }${
                                contentLink.name &&
                                contentLink.name.indexOf('navbar__no-image') >
                                    -1
                                    ? ' navbar__no-link--no-image'
                                    : ''
                            }`}
                            dangerouslySetInnerHTML={{
                                __html: contentLink.name,
                            }}
                        ></div>
                    )}
                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <ul className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-header">
                        {logoSrc && <img alt="logo" src={logoSrc} height="60" />}
                        {!contentLink ? (
                            <span
                                className="navbar__icon navbar__icon--close"
                                onClick={toggleMenu}
                            ></span>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>
                    {width < 768 &&
                        links.length > 0 &&
                        links[0].mobileLinks &&
                        links[0].mobileLinks.length > 0 && (
                            <div className="navbar__item-swipe">
                                {links[0].mobileLinks.map((x, i) => (
                                    <div
                                        key={i}
                                        className="navbar__item-swipe-image"
                                        dangerouslySetInnerHTML={{
                                            __html: x.name,
                                        }}
                                    ></div>
                                ))}
                            </div>
                        )}
                    {width < 768 &&
                        contentLink &&
                        !contentLink.url &&
                        contentLink.mobileLinks &&
                        contentLink.mobileLinks.length > 0 && (
                            <div className="navbar__item-swipe">
                                {contentLink.mobileLinks.map((x, i) => (
                                    <div
                                        key={i}
                                        className="navbar__item-swipe-image"
                                        dangerouslySetInnerHTML={{
                                            __html: x.name,
                                        }}
                                    ></div>
                                ))}
                            </div>
                        )}
                    {links.length > 0 &&
                        links.map(
                            (link, i) =>
                                hasNameOrChildren(link) && (
                                    <li
                                        className={`navbar__item ${
                                            link.attributes !== undefined &&
                                            link.attributes.cssValue !==
                                                undefined
                                                ? link.attributes.cssValue +
                                                  '-li'
                                                : ''
                                        }`}
                                        key={`${link.name}-${i}`}
                                    >
                                        <NavigationItem
                                            width={width}
                                            links={link.links}
                                            contentLink={link}
                                            listLength={links.length}
                                        />{' '}
                                    </li>
                                )
                        )}
                    {additionalHeaderLinks.length > 0 && (
                        <Fragment>
                            {additionalHeaderLinks.map(
                                ({ text, href }, index) => (
                                    <li
                                        className="additional-links"
                                        key={`subnavCompact-${index}`}
                                    >
                                        <a
                                            className="additional-links--link"
                                            href={href}
                                        >
                                            {text}
                                        </a>
                                    </li>
                                )
                            )}
                            <li className="nav-item-mobile">
                                <Countries />
                                <ShowVat isMobile={true} />
                            </li>
                        </Fragment>
                    )}
                </ul>
            )}
        </Fragment>
    );
};

export default NavigationItem;
